import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  BlogPostDetailObsModel,
  BlogTagModel,
} from 'src/app/core/model/object/blog-model';

@Injectable()
export class BlogShared {
  constructor() {}

  private _selectedRemovingPostId: string;
  private _selectedRemovingId: number;
  private _followedSuggestedUsernames: string[] = [];
  private _pendingSuggestedUsernames: string[] = [];
  private selectedUsername = '';
  private _blogZIndex = 10;
  private _blogSelectedTag: BlogTagModel;
  private _newUsername: string;

  public get newUsername(): string {
    return this._newUsername;
  }
  public set newUsername(value: string) {
    this._newUsername = value;
  }

  public get selectedRemovingId(): number {
    return this._selectedRemovingId;
  }
  public set selectedRemovingId(value: number) {
    this._selectedRemovingId = value;
  }
  public get selectedRemovingPostId(): string {
    return this._selectedRemovingPostId;
  }
  public set selectedRemovingPostId(value: string) {
    this._selectedRemovingPostId = value;
  }
  public get followedSuggestedUsernames(): string[] {
    return this._followedSuggestedUsernames;
  }
  public set followedSuggestedUsernames(value: string[]) {
    this._followedSuggestedUsernames = value;
  }
  public get pendingSuggestedUsernames(): string[] {
    return this._pendingSuggestedUsernames;
  }
  public set pendingSuggestedUsernames(value: string[]) {
    this._pendingSuggestedUsernames = value;
  }
  public get blogZIndex() {
    return this._blogZIndex;
  }
  public set blogZIndex(value) {
    this._blogZIndex = value;
  }

  public get blogSelectedTag(): BlogTagModel {
    return this._blogSelectedTag;
  }
  public set blogSelectedTag(value: BlogTagModel) {
    this._blogSelectedTag = value;
  }

  private blogTabSelectedObs = new BehaviorSubject<boolean>(false);
  blogTabSelectedObs$ = this.blogTabSelectedObs.asObservable();

  temp = new BlogPostDetailObsModel('-1', '-1', '-1');
  private blogOpenDetailObs = new BehaviorSubject<BlogPostDetailObsModel>(
    this.temp
  );
  blogOpenDetailObs$ = this.blogOpenDetailObs.asObservable();

  private blogCloseProfileObs = new BehaviorSubject<boolean>(false);
  blogCloseProfileObs$ = this.blogCloseProfileObs.asObservable();

  private blogOpenDetailCommentsObs =
    new BehaviorSubject<BlogPostDetailObsModel>(this.temp);
  blogOpenDetailCommentsObs$ = this.blogOpenDetailCommentsObs.asObservable();

  private blogOpenProfileObs = new BehaviorSubject<boolean>(false);
  blogOpenProfileObs$ = this.blogOpenProfileObs.asObservable();

  private blogScrollToCommentsObs = new BehaviorSubject<boolean>(false);
  blogScrollToCommentsObs$ = this.blogScrollToCommentsObs.asObservable();

  private openBlogWithTagObs = new BehaviorSubject<number>(-1);
  openBlogWithTagObs$ = this.openBlogWithTagObs.asObservable();

  private openBlogImageCropperObs = new BehaviorSubject<boolean>(false);
  openBlogImageCropperObs$ = this.openBlogImageCropperObs.asObservable();

  private deleteBlogImageObs = new BehaviorSubject<boolean>(false);
  deleteBlogImageObs$ = this.deleteBlogImageObs.asObservable();

  private showBlogNotificationObs = new BehaviorSubject<boolean>(false);
  showBlogNotificationObs$ = this.showBlogNotificationObs.asObservable();

  private hideBlogNotificationObs = new BehaviorSubject<boolean>(false);
  hideBlogNotificationObs$ = this.hideBlogNotificationObs.asObservable();

  private simplePopupActionObs = new BehaviorSubject<boolean>(false);
  simplePopupActionObs$ = this.simplePopupActionObs.asObservable();

  private simplePopupShareActionObs = new BehaviorSubject<boolean>(false);
  simplePopupShareActionObs$ = this.simplePopupShareActionObs.asObservable();

  private blockPopupActionObs = new BehaviorSubject<boolean>(false);
  blockPopupActionObs$ = this.blockPopupActionObs.asObservable();

  private removePostPopupActionObs = new BehaviorSubject<boolean>(false);
  removePostPopupActionObs$ = this.removePostPopupActionObs.asObservable();

  private removePostObs = new BehaviorSubject<boolean>(false);
  removePostObs$ = this.removePostObs.asObservable();

  private openProfileObs = new BehaviorSubject<boolean>(false);
  openProfileObs$ = this.openProfileObs.asObservable();

  private closeCreatePostObs = new BehaviorSubject<boolean>(false);
  closeCreatePostObs$ = this.closeCreatePostObs.asObservable();

  private closeAndUpdateCreatePostObs = new BehaviorSubject<boolean>(false);
  closeAndUpdateCreatePostObs$ =
    this.closeAndUpdateCreatePostObs.asObservable();

  private exitCreatePostObs = new BehaviorSubject<boolean>(false);
  exitCreatePostObs$ = this.exitCreatePostObs.asObservable();

  private usernameChangeObs = new BehaviorSubject<boolean>(false);
  usernameChangeObs$ = this.usernameChangeObs.asObservable();

  blogTabSelected() {
    this.blogTabSelectedObs.next(true);
    this.blogTabSelectedObs.next(false);
  }

  blogOpenDetail(id: string, postId: string) {
    const temp = new BlogPostDetailObsModel('', id, postId);
    this.blogOpenDetailObs.next(temp);
    this.blogOpenDetailObs.next(this.temp);
  }

  blogOpenProfile(username: string) {
    this.selectedUsername = username;
    this.blogOpenProfileObs.next(true);
    this.blogOpenProfileObs.next(false);
  }

  blogCloseProfile() {
    this.blogCloseProfileObs.next(true);
    this.blogCloseProfileObs.next(false);
  }

  blogOpenDetailComments(id: string, postId: string) {
    const temp = new BlogPostDetailObsModel('', id, postId);
    this.blogOpenDetailCommentsObs.next(temp);
    this.blogOpenDetailCommentsObs.next(this.temp);
  }

  blogScrollToComments() {
    this.blogScrollToCommentsObs.next(true);
    this.blogScrollToCommentsObs.next(false);
  }

  openBlogWithTag(id: number) {
    this.openBlogWithTagObs.next(id);
    this.openBlogWithTagObs.next(-1);
  }

  openBlogImageCropper() {
    this.openBlogImageCropperObs.next(true);
    this.openBlogImageCropperObs.next(false);
  }

  deleteBlogImage() {
    this.deleteBlogImageObs.next(true);
    this.deleteBlogImageObs.next(false);
  }

  showBlogNotification() {
    this.showBlogNotificationObs.next(true);
    this.showBlogNotificationObs.next(false);
  }

  hideBlogNotification() {
    this.hideBlogNotificationObs.next(true);
    this.hideBlogNotificationObs.next(false);
  }

  simplePopupAction() {
    this.simplePopupActionObs.next(true);
    this.simplePopupActionObs.next(false);
  }

  simplePopupShareAction() {
    this.simplePopupShareActionObs.next(true);
    this.simplePopupShareActionObs.next(false);
  }

  blockPopupAction() {
    this.blockPopupActionObs.next(true);
    this.blockPopupActionObs.next(false);
  }

  removePostPopupAction(postId: string, id: number) {
    this.selectedRemovingPostId = postId;
    this.selectedRemovingId = id;
    this.removePostPopupActionObs.next(true);
    this.removePostPopupActionObs.next(false);
  }

  removePost() {
    this.removePostObs.next(true);
    this.removePostObs.next(false);
  }

  closeCreatePost() {
    this.closeCreatePostObs.next(true);
    this.closeCreatePostObs.next(false);
  }

  closeAndUpdateCreatePost() {
    this.closeAndUpdateCreatePostObs.next(true);
    this.closeAndUpdateCreatePostObs.next(false);
  }

  exitCreatePost() {
    this.exitCreatePostObs.next(true);
    this.exitCreatePostObs.next(false);
  }

  openProfile(username: string) {
    this.selectedUsername = username;
    this.openProfileObs.next(true);
    this.openProfileObs.next(false);
  }

  usernameChange(username: string) {
    this.newUsername = username;
    this.usernameChangeObs.next(true);
    this.usernameChangeObs.next(false);
  }

  getSelectedUsername(): string {
    return this.selectedUsername;
  }
}
